import * as React from "react"
import { FooterInterface, SpecificLink, LinkInterface } from "../config/interfaces";
// @ts-ignore
import anime from "animejs";
// @ts-ignore
import { FreeMode } from 'swiper';
// @ts-ignore
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/free-mode";

const THEMEURL = window.drupalSettings ? `/${window.drupalSettings.path.themeUrl}` : '/themes/custom/mx_aguas_firmes_theme';

export default ({ linkList, sponsors, socialNetwork, lang, subfooter }: FooterInterface) => {
    const starList = [1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1];

    React.useEffect(() => {
        anime({
            targets: '.star-animate',
            loop: true,
            opacity: 1,
            duration: Math.random() * 10000,
            direction: 'alternate',
            delay: function (el: any, i: any, l: any) {
                return Math.random() * 10000;
            },
            endDelay: function (el: any, i: any, l: any) {
                return Math.random() * 10000;
            }
        });
    }, [])

    return (
        <React.Fragment>
            <div className='af-footer__bg'>
                <img className='af-footer__image' src={`${THEMEURL}/sources/dist/assets/images/general/footer.jpg`} alt="Footer" title="Footer" />
                <ul className='stars'>
                    {starList.map((i: number, j: number) => (
                        <li key={j} className={`star ${i ? 'star-animate' : ''}`}></li>
                    ))}
                </ul>
            </div>
            <div className="af-footer__container">
                <section className="af-footer__sponsors">
                    <img className='af-footer__wave' src={`${THEMEURL}/sources/dist/assets/images/general/waves.svg`} alt="Waves" title="Waves" />
                    <div className="af-footer__list-container">
                        <p className="af-footer__title">{lang == 'es' ? 'Un proyecto de' : 'A project of'}</p>
                        <div className="af-footer__sponsors-image-list">
                            {sponsors.map((sponsor: SpecificLink, index: number) => (
                                <div className='af-footer__sponsors-image' key={index}>
                                    <a href={sponsor.url} target={sponsor.target} rel="noopener">
                                        <img src={sponsor.description} alt={sponsor.title} title={sponsor.title} />
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                <section className="af-footer__group">
                    <section id='newsletterForm' className="af-footer__newsletter">
                        <p className="af-footer__title">Newsletter</p>
                    </section>
                    <p>Al inscribirse a nuestro newsletter acepta los <a target="_blank" href={subfooter[0].field_tyc.url}>términos y condiciones</a> de uso con la finalidad de gestionar su suscripción a la newsletter y proceder al envío de información.</p>
                    <section className="af-footer__map-site">
                        <p className="af-footer__title">{lang == 'es' ? 'Mapa del sitio' : 'Site Map'}</p>
                        <ul className="map-site">
                            {linkList.map((link: LinkInterface, index: number) => (
                                <li key={index} className="map-site__item"><a href={link.url} target={link.target}>{link.title}</a></li>
                            ))}
                        </ul>
                    </section>
                    <section className="af-footer__follow-us">
                        <p className="af-footer__title">{lang == 'es' ? 'Síguenos en' : 'Follow us on'}:</p>
                        <ul className="social-network">
                            {socialNetwork.map((social: SpecificLink, index: number) => (
                                <li key={index} className="social-network__item"><a href={social.url} target={social.target} rel="noopener"><img src={social.description} width="25" height="25" alt={social.title} title={social.title} /></a></li>
                            ))}
                        </ul>
                    </section>
                </section>
            </div>
            <div className="subFooter">
                <div className="linkssubfoot1">
                    <span>©2022 Anheuser-Bush Inbev S.A</span>
                </div>
                <div className="linkssubfoot2">
                  <a target="_blank" href={subfooter[0].field_tyc.url}>{subfooter[0].field_tyc.title}</a>
                  <a target="_blank" href={subfooter[0].field_avi.url}>{subfooter[0].field_avi.title}</a>
                </div>
            </div>
        </React.Fragment >
    )
}